module.exports = __webpack_public_path__ + "img/围场旅游.df44b0a9.jpg";